import { logsApi } from '../../shared/common/api/endpoints/logsApi';
import { safeLocalStorage, safeSessionStorage } from './safeStorage';

let currentHit: string | null = null;
let currentPathname: string | null = null;
let heartbeatTimer: ReturnType<typeof setInterval> | null = null;

const HEARTBEAT_INTERVAL = 3000;

const isAuthorized = (): boolean => {
    const token = safeLocalStorage.getItem('access') || safeSessionStorage.getItem('access');
    return !!token;
};

export const generateHit = (): string => {
    if (currentHit === null || window.location.pathname !== currentPathname) {
        let d = new Date().getTime();

        if (
            typeof performance !== 'undefined' &&
            typeof performance.now === 'function'
        ) {
            d += performance.now();
        }

        currentHit = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            let r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);

            return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
        });

        currentPathname = window.location.pathname;
    }

    return currentHit;
};

const stopHeartbeat = () => {
    if (heartbeatTimer !== null) {
        clearInterval(heartbeatTimer);
        heartbeatTimer = null;
    }
};

const sendHeartbeat = () => {
    if (!isAuthorized() || !currentHit) return;

    logsApi.sendHit(currentHit, window.location.href, 3)?.catch((err) => {
        if (err.response?.status !== 401) {
            console.error(err);
        }
    });
};

const startHeartbeat = () => {
    stopHeartbeat();
    heartbeatTimer = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL);
};

const handleVisibilityChange = () => {
    if (document.visibilityState === 'hidden') {
        if (currentHit) {
            logsApi.sendBeaconHit(currentHit, window.location.href, 3);
        }
        stopHeartbeat();
    } else {
        if (isAuthorized() && currentHit) {
            startHeartbeat();
        }
    }
};

export const sendPageHit = () => {
    if (!isAuthorized()) return;

    // Останавливаем heartbeat предыдущей страницы
    stopHeartbeat();

    // Отправляем page view
    const hit = generateHit();
    logsApi.sendHit(hit, window.location.href, 1)?.catch((err) => {
        if (err.response?.status !== 401) {
            console.error(err);
        }
    });

    // Запускаем heartbeat только если вкладка активна
    if (document.visibilityState !== 'hidden') {
        startHeartbeat();
    }
};

export const bindClickObserver = () => {
    document.body.addEventListener('click', () => {
        if (!isAuthorized()) return;

        const hit = generateHit();
        logsApi.sendHit(hit, window.location.href, 2)?.catch((err) => {
            if (err.response?.status !== 401) {
                console.error(err);
            }
        });
    });

    // Пауза/возобновление heartbeat при смене видимости вкладки
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Финальный heartbeat при закрытии вкладки
    window.addEventListener('beforeunload', () => {
        if (!isAuthorized() || !currentHit) return;

        stopHeartbeat();
        logsApi.sendBeaconHit(currentHit, window.location.href, 3);
    });
};
